/**
 * Convets decimal hour to sexagesimal and pads the result.
 * Ex. 8.5 -> 08:30.
 */

export const decimalHourToSexagesimal = (decimalHour: number): string => {
    const hours = Math.floor(decimalHour);
    const minutes = decimalHour % 1 * 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
  }